import { Component, OnInit } from '@angular/core'
import { ActivatedRoute, Params } from '@angular/router'

import { MovieService } from '../shared/movie.service'
import { Movie, ShowtimesByTheatre } from '../shared/movie.model'
import { Trailer } from '../shared/trailer.model'

import { Observable } from 'rxjs/Observable'

@Component({
  selector: 'cm-movie-detail',
  templateUrl: './movie-detail.component.html',
  styleUrls: ['./movie-detail.component.css']
})
export class MovieDetailComponent implements OnInit {

  movieId: number

  movie: Movie
  trailer: Trailer
  sceneImage: string

  constructor(private movieService: MovieService,
    private route: ActivatedRoute) { }

  ngOnInit() {
    this.route.params
      .switchMap((params: Params) => {
        this.movieId = params['id']
        return this.movieService.getMovie(this.movieId, 1)
      })
      .subscribe((movie: Movie) => {
        this.movie = movie
        this.sceneImage = this.movie.sceneImages[Math.floor(Math.random() * this.movie.sceneImages.length)]
      })

    this.route.params
      .switchMap((params: Params) => {
        this.movieId = params['id']
        return this.movieService.getTrailer(this.movieId)
      })
      .subscribe((trailer: Trailer) => this.trailer = trailer)
  }

}



// WEBPACK FOOTER //
// C:/Users/florian.gadal/Workspace/cinenow-web/src/app/movies/movie-detail/movie-detail.component.ts